import { NBA_PLAY } from '@sorare/core/src/constants/routes';

import { NoCardEntryConfirm as USSportsNoCardEntryConfirm } from '@sorare/us-sports/src/components/lobby/NoCardEntry/routes/confirm';

const NoCardEntryConfirm = () => (
  <USSportsNoCardEntryConfirm lobbyRoute={NBA_PLAY} />
);

export default NoCardEntryConfirm;
